module.exports = __webpack_public_path__ + "5c07fe59e84e4594ffa87ae1a72b130d.ttf";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/Fantasque/FantasqueSansMono-RegItalic.ttf
// module id = 421
// module chunks = 0